import {
  Connection,
  ConnectionRequest,
  DoctorLink,
  DoctorLinkRequest,
  FullUser,
  PatientLink,
  PatientLinkRequest,
  RelationRequestsCount,
  RequestCounters,
  SuggestedUser,
} from './relation-request.interface';

export const mapRequestCount: (count: RequestCounters) => RelationRequestsCount = (
  count: RequestCounters,
): RelationRequestsCount => ({
  verifiedCount: count.verified_count,
  requestsSent: count.requests_sent,
  requestsReceived: count.requests_received,
});

export const mapPatientLink: (link: PatientLinkRequest) => PatientLink = (link: PatientLinkRequest) => ({
  relatedUser: link.patient,
  entityId: link.entity_id,
  invitationDate: link.invitation_date,
  acceptanceDate: link.acceptance_date,
  diseases: link.diseases,
});

export const mapDoctorLink: (link: DoctorLinkRequest) => DoctorLink = (link: DoctorLinkRequest) => ({
  relatedUser: link.doctor,
  entityId: link.entity_id,
  invitationDate: link.invitation_date,
  acceptanceDate: link.acceptance_date,
  specialties: link.specialties,
});

export const mapConnection: (connection: Connection) => ConnectionRequest = (connection: Connection) => ({
  relatedUser: connection.user,
  invitationDate: connection.invitation_date,
  acceptanceDate: connection.acceptance_date,
});

export const userReaction: (user: FullUser) => SuggestedUser = (user: FullUser) => {
  return {
    user: {
      user_id: user.user_id,
      displayed_name: user.displayed_name,
      is_admin: user.is_admin,
      chat: user.chat,
      account_status: user.account_status,
    },
    connectionDetails: user.reaction.connection_details,
    doctorLinkStatus: user.reaction.doctor_link_status,
    patientLinkStatus: user.reaction.patient_link_status,
  };
};
